import axios from "axios";
import { useQuery } from "react-query";
import { Config } from "../config";

const notificationsBaseUrl = Config.serviceUrls.notificationsBaseUrl;

const getNotifications = async ({ queryKey }) => {
  const [, pageSize, pageNumber, withData] = queryKey;
  const params = { pageSize, pageNumber, withData };
  const axiosRes = await axios.get(
    `${notificationsBaseUrl}/Notification/getWebNotifications`,
    { params }
  );
  const apiRes = axiosRes.data;
  if (apiRes.statusCode !== 200) {
    throw new Error(apiRes.message);
  }
  return apiRes;
};

/**
 * Fetches web notifications.
 *
 * Defaults are tuned to avoid the previous back-to-back polling of
 * `getWebNotifications` (staleTime 2s + refetchOnWindowFocus). Real-time updates
 * are delivered via Firebase `onMessage` in the header, so a long stale window
 * with a slow fallback poll is sufficient. Callers can override any option
 * (e.g. list pages that want fresher data on mount).
 *
 * @param {number} pageSize
 * @param {number} pageNumber
 * @param {boolean} [withData=true]
 * @param {import("react-query").UseQueryOptions} [options]
 */
export const useGetNotifications = (
  pageSize,
  pageNumber,
  withData = true,
  options = {}
) => {
  return useQuery(
    ["notifications", pageSize, pageNumber, withData],
    getNotifications,
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      ...options,
    }
  );
};
